import { useState } from "react";

export default function RichiestaStand() {
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");
  const [charCount, setCharCount] = useState(0);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    const form = e.currentTarget;
    const data = new FormData(form);

    const nome = (data.get("nome") as string || "").trim();
    const cognome = (data.get("cognome") as string || "").trim();
    const telefono = (data.get("telefono") as string || "").trim();
    const testo = (data.get("testo") as string || "").trim();

    if (!nome || !cognome || !telefono || !testo) {
      setError("Tutti i campi sono obbligatori.");
      return;
    }
    if (testo.length < 200) {
      setError(`Il messaggio deve essere di almeno 200 caratteri (attualmente ${testo.length}).`);
      return;
    }

    setSubmitting(true);
    try {
      const params = new URLSearchParams();
      params.append("nome", nome);
      params.append("cognome", cognome);
      params.append("telefono", telefono);
      params.append("testo", testo);
      params.append("_to", "associazionelatenda@libero.it");
      params.append("_subject", "richiesta partecipazione stand - food truck festa della tammorra 2026");

      const res = await fetch("https://readdy.ai/api/form/d704ljmdp0k8rarn886g", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });

      if (res.ok) {
        setSubmitted(true);
        form.reset();
        setCharCount(0);
      } else {
        setError("Errore durante l\'invio. Riprova più tardi.");
      }
    } catch {
      setError("Errore di connessione. Riprova più tardi.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <section id="richiesta-stand" className="w-full bg-[#2e3b0e] py-16 px-4">
      <div className="max-w-2xl mx-auto">
        {/* Title */}
        <h2 className="font-['Londrina_Solid'] text-[#c8e04a] text-5xl md:text-6xl tracking-widest uppercase text-center mb-4">
          Richiesta Stand
        </h2>

        {/* Divisore */}
        <div className="flex items-center justify-center gap-4 mb-8">
          <div className="h-px flex-1 bg-[#c8e04a]/30" />
          <div className="w-2 h-2 rounded-full bg-[#c8e04a]" />
          <div className="h-px flex-1 bg-[#c8e04a]/30" />
        </div>

        <p className="font-['Londrina_Solid'] text-white/70 text-lg tracking-wider text-center mb-8">
          Vuoi partecipare con uno stand o food truck? Compila il modulo e ti contatteremo.
        </p>

        {submitted ? (
          <div className="bg-[#475816] border-2 border-[#c8e04a] rounded-lg p-8 text-center">
            <div className="w-14 h-14 flex items-center justify-center mx-auto mb-4">
              <i className="ri-check-double-line text-[#c8e04a] text-5xl"></i>
            </div>
            <p className="font-['Londrina_Solid'] text-[#c8e04a] text-2xl tracking-wider uppercase">
              Richiesta inviata!
            </p>
            <p className="font-['Londrina_Solid'] text-white/70 text-base mt-2 tracking-wider">
              Ti contatteremo al più presto.
            </p>
          </div>
        ) : (
          <form
            data-readdy-form
            id="richiesta-stand-form"
            onSubmit={handleSubmit}
            className="flex flex-col gap-5"
          >
            {/* Nome e Cognome */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="flex flex-col gap-2">
                <label className="font-['Londrina_Solid'] text-[#c8e04a] text-base tracking-widest uppercase">
                  Nome <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  name="nome"
                  required
                  placeholder="Il tuo nome"
                  className="bg-[#1e2708] border border-[#c8e04a]/30 focus:border-[#c8e04a] rounded-md px-4 py-3 text-white font-['Londrina_Solid'] text-base tracking-wider outline-none transition-colors placeholder:text-white/30"
                />
              </div>
              <div className="flex flex-col gap-2">
                <label className="font-['Londrina_Solid'] text-[#c8e04a] text-base tracking-widest uppercase">
                  Cognome <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  name="cognome"
                  required
                  placeholder="Il tuo cognome"
                  className="bg-[#1e2708] border border-[#c8e04a]/30 focus:border-[#c8e04a] rounded-md px-4 py-3 text-white font-['Londrina_Solid'] text-base tracking-wider outline-none transition-colors placeholder:text-white/30"
                />
              </div>
            </div>

            {/* Telefono */}
            <div className="flex flex-col gap-2">
              <label className="font-['Londrina_Solid'] text-[#c8e04a] text-base tracking-widest uppercase">
                Telefono <span className="text-red-400">*</span>
              </label>
              <input
                type="tel"
                name="telefono"
                required
                placeholder="Es. +39 333 1234567"
                className="bg-[#1e2708] border border-[#c8e04a]/30 focus:border-[#c8e04a] rounded-md px-4 py-3 text-white font-['Londrina_Solid'] text-base tracking-wider outline-none transition-colors placeholder:text-white/30"
              />
            </div>

            {/* Messaggio */}
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between">
                <label className="font-['Londrina_Solid'] text-[#c8e04a] text-base tracking-widest uppercase">
                  Descrizione <span className="text-red-400">*</span>
                </label>
                <span className={`font-['Londrina_Solid'] text-sm tracking-wider ${charCount >= 200 ? "text-[#c8e04a]" : "text-white/40"}`}>
                  {charCount}/500 {charCount < 200 && `(min. 200)`}
                </span>
              </div>
              <textarea
                name="testo"
                required
                rows={6}
                maxLength={500}
                placeholder="Descrivi il tuo stand o food truck, tipologia di prodotti, dimensioni necessarie... (minimo 200 caratteri)"
                onChange={(e) => setCharCount(e.target.value.length)}
                className="bg-[#1e2708] border border-[#c8e04a]/30 focus:border-[#c8e04a] rounded-md px-4 py-3 text-white font-['Londrina_Solid'] text-sm tracking-wider outline-none transition-colors resize-none placeholder:text-white/30 leading-relaxed"
              />
            </div>

            {/* Error */}
            {error && (
              <div className="bg-red-900/40 border border-red-500/50 rounded-md px-4 py-3">
                <p className="font-['Londrina_Solid'] text-red-300 text-sm tracking-wider">{error}</p>
              </div>
            )}

            {/* Submit */}
            <button
              type="submit"
              disabled={submitting}
              className="font-['Londrina_Solid'] bg-[#475816] hover:bg-[#5a6e1a] disabled:opacity-60 text-[#c8e04a] border-2 border-[#c8e04a] text-xl tracking-widest uppercase px-8 py-4 rounded-full transition-colors duration-200 cursor-pointer whitespace-nowrap mt-2"
            >
              {submitting ? "Invio in corso..." : "Invia Richiesta"}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
